import React from "react";
import "@fontsource/dm-sans/latin.css"; // This imports all weights for the Latin subset
import "./src/styles/global.css"; // Import your global styles
import "./src/styles/responsive.css";

import Layout from "./src/components/Layout";

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};